/**
 * The server builds shareable links (e.g. `inviteLink`) from its own
 * FRONTEND_URL, which doesn't know the host the user is actually on — an ngrok
 * preview, a tunnel, local dev. So keep the path from the server and take the
 * origin from the browser, same as every other share link here. A malformed
 * server string is returned as-is rather than throwing at click time.
 */
export function withCurrentOrigin(
    link: string,
    origin: string = window.location.origin,
): string {
    try {
        const url = new URL(link);
        return `${origin}${url.pathname}${url.search}${url.hash}`;
    } catch {
        return link;
    }
}
